<script>
export default {
  computed: {
    menu() {
      return () => import(`@/components/Themes/${this.$cookies.get('theme') ?? 'default'}/Menu`);
    }
  },
  methods: {},
};
</script>
<template>
  <component :is="menu" v-on:open-drawer="$emit('open-drawer')" v-if="menu"></component>
</template>